var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2 25.2C39.2 18.5165 41.855 12.1068 46.5809 7.38091C51.3068 2.65499 57.7165 0 64.4 0L84 0V19.6C84 26.2835 81.345 32.6932 76.6191 37.4191C71.8932 42.145 65.4835 44.8 58.8 44.8H44.8V84H39.2V61.6H25.2C18.5165 61.6 12.1068 58.945 7.38091 54.2191C2.65499 49.4932 0 43.0835 0 36.4L0 16.8H19.6C27.5184 16.8 34.58 20.4512 39.2 26.1576V25.2ZM45.6176 34.4176L62.4176 17.6176L66.3824 21.5824L49.5824 38.3824L45.6176 34.4176ZM34.4176 55.1824L17.6176 38.3824L21.5824 34.4176L38.3824 51.2176L34.4176 55.1824Z",
    fill: "#5EE45C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.1ae91fbc762aef38b88f282451c2dbec.svg";
export { ForwardRef as ReactComponent };